import pdfjs from 'pdfjs-dist/build/pdf';

const pdfCMapOptions = {
  cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
};

export default pdfCMapOptions;
